import React from 'react';

const WindowSizeContext = React.createContext();

export default WindowSizeContext;
